import {useListView} from '../../core/ListViewProvider'
import {BalancesListToolbar} from './BalanceListToolbar'
import {BalancesListGrouping} from './BalancesListGrouping'
import {BalancesListSearchComponent} from './BalancesListSearchComponent'

const BalancesListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <BalancesListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <BalancesListGrouping /> : <BalancesListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {BalancesListHeader}
